<template>
  <Modal :visible.sync='show' :title='title' @handleClose='close'>
    <el-form v-loading='loading' >
      <el-row v-if='gatewayDetail.name'>
        <el-col :span='12'>
          <el-form-item :label="$t('integration.gateway_name_')">
            <!--网关名称-->
            {{ gatewayDetail.name }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--mac地址-->
          <el-form-item :label="$t('mac地址')">
            {{ gatewayDetail.mac }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--短地址-->
          <el-form-item :label="$t('短地址')">
            {{ gatewayDetail.short_addr }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--是否已激活-->
          <el-form-item :label="$t('是否已激活')">
            {{ ENUM_RE_YESNO[gatewayDetail.edited].title }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--网关序列号-->
          <el-form-item :label="$t('网关序列号')">
            {{ gatewayDetail.sn }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--所属载体-->
          <el-form-item :label="$t('device.belong_carrier')">
            {{ gatewayDetail.carrierRspList.map(item=>item.keycode).join(',') }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--zigbee参数状态-->
          <el-form-item :label="$t('zigbee参数状态')">
            {{ ENUM_RE_ZIGBEE_PARAMS_STATUS[gatewayDetail.parameter_status].title }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--电源状态-->
          <el-form-item :label="$t('电源状态')">
            {{ ENUM_RE_GATEWAY_POWER_STATUS[gatewayDetail.power_status].title }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--TCP连接状态-->
          <el-form-item :label="$t('TCP连接状态')">
            {{ ENUM_RE_TCP_STATUS[gatewayDetail.tcp_status].title }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--LTE连接状态-->
          <el-form-item :label="$t('LTE连接状态')">
            {{ ENUM_RE_LTE_STATUS[gatewayDetail.lte_status].title }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--飞行模式-->
          <el-form-item :label="$t('飞行模式')">
            {{ ENUM_RE_AIRPLANE_MODE[gatewayDetail.flight_mode].title }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--IP-->
          <el-form-item :label="$t('IP')">
            {{ gatewayDetail.ip }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--自身IP属性-->
          <el-form-item :label="$t('自身IP属性')">
            {{ gatewayDetail.self_ip }}
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <!--描述-->
          <el-form-item :label="$t('描述')">
            {{ gatewayDetail.description }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button type='primary' @click="close">{{$t('关闭')}}</el-button>
    </template>
  </Modal>
</template>
<script>
import { gatewayGetid } from '@/api/api.js'
import { ENUM_RE_YESNO } from '@/common/enum/reverse/global'
import {
  ENUM_RE_AIRPLANE_MODE,
  ENUM_RE_GATEWAY_POWER_STATUS, ENUM_RE_LTE_STATUS,
  ENUM_RE_TCP_STATUS,
  ENUM_RE_ZIGBEE_PARAMS_STATUS
} from '@/common/enum/reverse/device'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gatewayId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ENUM_RE_AIRPLANE_MODE: () => ENUM_RE_AIRPLANE_MODE,
    ENUM_RE_LTE_STATUS: () => ENUM_RE_LTE_STATUS,
    ENUM_RE_TCP_STATUS: () => ENUM_RE_TCP_STATUS,
    ENUM_RE_GATEWAY_POWER_STATUS: () => ENUM_RE_GATEWAY_POWER_STATUS,
    ENUM_RE_YESNO: () => ENUM_RE_YESNO,
    ENUM_RE_ZIGBEE_PARAMS_STATUS: () => ENUM_RE_ZIGBEE_PARAMS_STATUS,
    show: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    title () {
      return `[${this.gatewayDetail.name}]-关联网关详情`
    }
  },
  watch: {
    gatewayId () {
      this.getGatewayDetail(this.gatewayId)
    }
  },
  data () {
    return {
      loading: false,
      gatewayDetail: { }
    }
  },
  methods: {
    getGatewayDetail (gatewayId) {
      this.loading = true
      gatewayGetid({ id: gatewayId }).then(({ result }) => {
        this.loading = false
        this.gatewayDetail = result
      })
    },
    close () {
      this.show = false
    }
  }
}
</script>

<style scoped lang='scss'>

</style>
